import { useEffect, useRef } from 'react'

import type { FlexPortion } from '@library/api-menu-experience'

import type { FlexPortionEditorState } from '../components/FlexPortionEditor'

type ReportFlexPortionsOnceParams = {
  isOpen: boolean
  recipeKey: string
  state: FlexPortionEditorState
  onPortionsLoaded?: (portions: FlexPortion[]) => void
}

/**
 * Reports the portion options once per open of the editor, when they first load.
 * Changing portions inside the open editor reloads the options but is not reported again.
 */
export const useReportFlexPortionsOnce = ({
  isOpen,
  recipeKey,
  state,
  onPortionsLoaded,
}: ReportFlexPortionsOnceParams) => {
  const reportedRecipeKeyRef = useRef<string | null>(null)

  useEffect(() => {
    if (!isOpen) {
      reportedRecipeKeyRef.current = null

      return
    }

    if (state.status === 'success' && reportedRecipeKeyRef.current !== recipeKey) {
      reportedRecipeKeyRef.current = recipeKey
      onPortionsLoaded?.(state.portions)
    }
  }, [isOpen, onPortionsLoaded, recipeKey, state])
}
